import React from 'react';
import Container from '@mui/material/Container';
import NavBar from './navBar'


const Resources = () => {
    const data = [{
        title: "Data",
        link: 'https://www.kaggle.com/datasets/dronio/SolarEnergy'
    }, {
        title:"React",
        link: "react.org"
    }]
    return(
        <div>
            <NavBar/>
            <h1>Resources</h1>
            
             {data.map((id) => {
                return(
                    <Container fixed>
                    <a key={id.link} target="blank" href={id.link}>
                    {id.title}
                  </a>
                  </Container>

                )

             })}
        </div>
    )
}

export default Resources